import Vue from "vue";
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        typeId: localStorage.getItem('switchTag') || '0' ,
        urlFalg: false,
        projectId: sessionStorage.getItem('projectId') || null,
        selfUserInfo:{},
    },
    watch:{
      selfUserInfo:{
        deep:true,
        handler(){
          console.log('dkskdks')
        }
      }

    },
    mutations:{
        changeId(state,payload) {
            state.typeId = payload
        },
        changUrlFalg(state,payload){
            state.urlFalg = payload
        },
        changProjectId(state,payload){
            state.projectId = payload
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js